{
  "title": "Assistente IA",
  "newChat": "Nuova chat",
  "untitled": "Senza titolo",
  "emptyHint": "Chiedi informazioni su dispositivi, campi, piani di irrigazione o attività recenti della tua azienda.",
  "placeholder": "Fai una domanda…",
  "send": "Invia",
  "spend": "Spesi ${{spent}} di ${{budget}} questo mese — ${{remaining}} rimanenti.",
  "budgetExceeded": "Questa azienda ha raggiunto il budget mensile dell'assistente IA.",
  "unavailable": "L'assistente IA non è disponibile in questo momento.",
  "experimental": "Sperimentale"
}
